import apiClient from './client';

/** 관리자: 회원 검색 (Spring Page 응답) */
export async function fetchMembers({ search = '', page = 0, size = 20 } = {}) {
  const params = { page, size };
  if (search.trim()) params.search = search.trim();
  const { data } = await apiClient.get('/admin/competition-members', { params });
  return data;
}

/** 관리자: 회원 정보 + 대회기록 → { member, records } */
export async function fetchMember(memberId) {
  const { data } = await apiClient.get(`/admin/competition-members/${memberId}`);
  return data;
}

export async function updateMember(memberId, payload) {
  const { data } = await apiClient.put(`/admin/competition-members/${memberId}`, payload);
  return data;
}

/** source 회원을 target 회원으로 병합 (source 삭제) */
export async function mergeMembers(sourceMemberId, targetMemberId) {
  const { data } = await apiClient.post('/admin/competition-members/merge', {
    sourceMemberId,
    targetMemberId,
  });
  return data;
}
